import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconCheckmark(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M17.662 7.25a1 1 0 0 1 .088 1.412l-7.945 9a1 1 0 0 1-1.533-.041l-3.056-3.857a1 1 0 0 1 1.568-1.242l2.313 2.92 7.153-8.104a1 1 0 0 1 1.412-.088Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
